(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-consented-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  let loaded = false;
  let initialized = false;
  const checkPermission = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    const consent = privacy.currentVisitorConsent();
    const allowed = consent.analytics === 'yes' && consent.marketing === 'yes'
      && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
    if (!allowed) {
      if (loaded) window.location.reload();
      return;
    }
    if (loaded) return;
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-PSH5M9QH';
    document.head.appendChild(script);
  };
  const initialize = () => {
    if (initialized) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    initialized = true;
    document.addEventListener('visitorConsentCollected', checkPermission);
    window.addEventListener('pageshow', checkPermission);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      if (!error) checkPermission();
    });
  };
  window.addEventListener('load', initialize, { once: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
